import dynamic from "next/dynamic";

import LottieAnimation from "@/components/shared/ui/LottieAnimation";
import logoAnimation from "@/public/ocp_loader.json";

const AnimatedLoader = () => <LottieAnimation animationData={logoAnimation} loop={true} />;

function FullPageLoaderComponent() {
	return (
		<div className="flex min-h-screen w-full items-center justify-center">
			<AnimatedLoader />
		</div>
	);
}

export function Loader() {
	return (
		<div className="flex h-full w-full justify-center">
			<AnimatedLoader />
		</div>
	);
}

export const FullPageLoader = dynamic(() => Promise.resolve(FullPageLoaderComponent), {
	ssr: false,
	loading: () => null,
});
export default dynamic(() => Promise.resolve(Loader), { ssr: false, loading: () => null });
